import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './tailwind.css';
import { AuthProvider } from "react-oidc-context";
import LogPage from './LogPage';
import { BrowserRouter } from 'react-router-dom';

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_oDeYmrQA8",
  client_id: "17dnm9s9f6bd760h4c69lfe0bh",
  // redirect_uri: "http://localhost:3000",
  // redirect_uri: "https://d39hs47lec3pp9.cloudfront.net",
  redirect_uri: "https://auracostai.accentureanalytics.com",
  response_type: "code",
  scope: "email openid phone",
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider {...cognitoAuthConfig}>
        <LogPage />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
